module.exports = __webpack_public_path__ + "fonts/NoirPro-SemiBold.ac97525f.eot";